import React, { Fragment } from 'react';
import { number, func } from 'prop-types';
import { renderToString } from 'react-dom/server';
import { FormattedPlural, IntlProvider } from 'react-intl';

import Button from '../../Button';
import { formatAmount } from '../../../utils'
import s from './index.module.css';

const OFFSET_BALLOON = 20;
const BALLOON_WIDTH = 262;
const BALLOON_MAX_HEIGHT = 350;

const Balloon = ({ address }) => (
  <div className={s.balloon}>
    <div className={s.header}>
      <p className={s.title}>{address}</p>
      <button type="button" id="balloonCloseButton" className={s.balloonClose} />
    </div>

    <div className={s.content}>$[[options.contentLayout panelMaxMapArea={0} minWidth={BALLOON_WIDTH} maxWidth={BALLOON_WIDTH} maxHeight={BALLOON_MAX_HEIGHT}]]</div>
    <div className={s.arrow} />
  </div>
);

export const BalloonLayout = (ymaps, address, onClick) => {
  const balloon = <Balloon address={address} />;

  const balloonLayout = ymaps.templateLayoutFactory.createClass(renderToString(balloon), {
    build() {
      this.constructor.superclass.build.call(this);

      this.onCloseClick = function(e) {
        e.preventDefault();
        this.events.fire('userclose');
      }.bind(this);
      
      this.element = this.getParentElement().children[0].children[0];
      this.applyElementOffset();

      this.closeButton = document.getElementById('balloonCloseButton');
      this.cartButton = document.getElementById('balloonCartButton');
      this.closeButton.addEventListener('click', this.onCloseClick);
      this.cartButton.addEventListener('click', onClick);
    },

    clear() {
      this.closeButton.removeEventListener('click', this.onCloseClick);
      this.cartButton.removeEventListener('click', onClick);

      this.constructor.superclass.clear.call(this);
    },

    onSublayoutSizeChange() {
      balloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

      if (!this.element) {
        return;
      }

      this.applyElementOffset();
      this.events.fire('shapechange');
    },

    applyElementOffset() {
      this.element.setAttribute(
        'style',
        `left:${-(this.element.offsetWidth / 2)}px; 
          top: ${-(this.element.offsetHeight + OFFSET_BALLOON)}px;
        `,
      );
    },

    getShape() {
      if (!this.element) {
        return balloonLayout.superclass.getShape.call(this);
      }

      const { offsetHeight, offsetWidth, offsetLeft, offsetTop } = this.element;

      return new ymaps.shape.Rectangle(
        new ymaps.geometry.pixel.Rectangle([
          [offsetLeft, offsetTop],
          [offsetLeft + offsetWidth, offsetTop + offsetHeight + OFFSET_BALLOON],
        ]),
      );
    },
  });

  return balloonLayout;
};

const BalloonContent = ({ price, delivery, quantity }) => {
  const days = delivery > 0
    ? <Fragment>Через {delivery}&nbsp;
      <FormattedPlural
        value={delivery}
        one={'день'}
        few={'дня'}
        many={'дней'}
        other={'дней'}
      />
    </Fragment>
    : 'Сегодня';

  return (
    <IntlProvider locale="ru" defaultLocale="ru">
      <div className={s.balloonContent}>
        <div className={s.delivery}>
          <span className={s.value}>
            {days}
          </span>
          <span className={s.description}>&nbsp;возможен самовывоз</span>
        </div>
        <div className={s.quantity}>
          <span className={s.value}>
            {quantity} шт.
          </span>
          <span className={s.description}>&nbsp;в наличии</span>
        </div>
        <div className={s.footer}>
          <span className={s.price}>
            {formatAmount(price, true)} ₽
          </span>
          <Button id="balloonCartButton" className={s.cartButton} view="button" background="white">
            Выбрать
          </Button>
        </div>
      </div>
    </IntlProvider>
  )
};

export const BalloonContentLayout = (templateLayoutFactory, price, delivery, quantity) => {
  const balloonContent = <BalloonContent price={price} delivery={delivery} quantity={quantity} />;

  const balloonContentLayout = templateLayoutFactory.createClass(renderToString(balloonContent));

  return balloonContentLayout;
};

BalloonContent.propTypes = {
  price: number,
  delivery: number,
  quantity: number,
  onClick: func,
};
